import {
    ORGANIZATIONSECTION_LOADING, GET_ORGANIZATIONSECTION_DATA_SUCCESS,
    GET_ORGANIZATIONSECTION_DATA_ERROR, ORGANIZATIONSECTION_END_LOADING, RESET_ORGANIZATIONSECTION
} from "../actions/actionOrganizationSection";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "organizationlist";

const initialState = {
    organizationlist: loadState(sessionKey, []),
    loading: false,
    organizationlisterror: ''
};

function reducerOrganizationSection(state = initialState, action) {

    switch (action.type) {
        case ORGANIZATIONSECTION_LOADING: {
            saveState(sessionKey, []);
            return {
                ...state,
                loading: true,
                organizationlist: [],
                organizationlisterror: ''
            };
        }

        case GET_ORGANIZATIONSECTION_DATA_SUCCESS: {
            let orglist = [
                ...action.payload
            ]

            saveState(sessionKey, orglist);

            return {
                ...state,
                loading: false,
                organizationlist: orglist,
                organizationlisterror: ''
            };
        }


        case GET_ORGANIZATIONSECTION_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                organizationlist: [],
                organizationlisterror: action.error
            }
        }

        case ORGANIZATIONSECTION_END_LOADING: {
            return {
                ...state,
                loading: false
            }
        }

        case RESET_ORGANIZATIONSECTION: {
            return {
                ...state,
                organizationlist: [],
                loading: false,
                organizationlisterror: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerOrganizationSection;
